var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1Four(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9a29 29 0 100 58 29 29 0 000-58zm0 54a25 25 0 110-49.999A25 25 0 0138 63zm4-35h-3.54L30 39.38V43h8v5h4v-5h3v-3h-3V28zm-4 12h-5.3l5.21-7H38v7z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Four.8bdf4883.svg";
export { SvgJ1Four as ReactComponent };